<template>
  <div>
    <NBar title="投放地址"/>
    <nut-textinput class="my-input" v-model="search" placeholder="请输入投放地址名称或详细地址" :clearBtnPersonnal="true">
      <template v-slot:clearBtn>
        <nut-icon type="cross"></nut-icon>
      </template>
    </nut-textinput>
    <m-list style="height:calc(100vh - 130px);" ref="list" :data.sync="list" :page.sync="page" :limit.sync="limit"
            @loadlist="getData">
      <div slot="list" v-for="(item,index) in list" :key="index" class='item'>
        <div class='content'>
          <div class='title'>
            <span class='name text-wrap'>{{ item.name }}</span>
            <div class="num" @click="openDevice(item)">
              <div style="display: flex;align-items: center;inline-size: max-content;">{{ item.deviceCount }}台</div>
              <img :src="require('../../../../resource/img/device/svg/settings.svg')"
                   style="margin-left:3px;width: 15px;height: 15px;">
            </div>
          </div>
          <span class='addr'>{{ item.provinceName + '省 ' + item.cityName + '市 ' + item.areaName + ' ' + item.address }}
          </span>
        </div>
        <div class='edit'>
          <div class='def'>
            <nut-checkbox class="checkbox" :false-value="0" :true-value="1" v-model='item.isDefault'
                          @change="checkTap($event,item)">设置默认地址
            </nut-checkbox>
          </div>
          <div class='btn-groups'>
            <div class='div-btn' @click='goAddress(item)'>
              <img :src='listIcon.address_icon_edit'/>
              <span>编辑</span>
            </div>
            <div class='div-btn' @click='delTap(item)'>
              <img :src='listIcon.address_icon_delect'/>
              <span>删除</span>
            </div>
          </div>
        </div>
      </div>
    </m-list>
    <nut-dialog title="提示" :visible="dialogShow" @ok-btn-click="del()" @cancel-btn-click="dialogShow=false"
                @close="dialogShow=false">
      <span>是否删除该地址?</span>
    </nut-dialog>
    <div class="bottom">
      <nut-button style="margin: 0 15px;border-radius: 5px;width:92%;" @click="goAddress()">添加投放地址</nut-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LaunchAddress',
  data () {
    return {
      search: '',
      user: null,
      listIcon: {
        address_icon_edit: require('@/resource/img/device/address_icon_edit.png'),
        address_icon_delect: require('@/resource/img/device/address_icon_delect.png'),
      },
      list: [],
      page: 1,
      limit: 10,
      id: null,
      dialogShow: false,
    }
  },
  activated () {
    this.user = this.$api.user
    this.getData()
  },
  methods: {
    getData () {
      this.$api.post({
        url: '/device/api/device/address/list',
        data: {
          page: this.page,
          limit: this.limit
        },
      }).then(res => {
        this.$refs.list.setRes(res)
      })
    },
    goAddress (item) {
      let query = {}
      if (item != null) {
        query.data = encodeURIComponent(JSON.stringify(item))
      }
      this.$router.push({
        path: '/device/AddressAdd',
        query: query
      })
    },
    delTap (item) {
      this.id = item.id
      this.dialogShow = true
    },
    del () {
      this.$api.delete({
        url: '/device/api/device/address/delete',
        id: this.id
      }).then(() => {
        this.onInfinite()
        this.dialogShow = false
      })
    },
    //打开设备列表
    openDevice (item) {
      this.$router.push({
        path: '/device/DeviceList',
        query: {
          addressId: item.id
        }
      })
    },
    checkTap (event, item) {
      item.isDefault = event ? 1 : 0
      this.$api.post({
        url: '/device/api/device/address/save',
        data: item
      }).then(() => {
        this.onInfinite()
      })
    }
  },
  beforeRouteLeave(to, form, next) {
    this.page = 1
    this.list = []
    next()
  }
}
</script>

<style scoped>
.item {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

.item .text-wrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item .content {
  background: #fff;
}

.item .content .title {
  margin: 0 12px;
  display: flex;
  height: 30px;
  line-height: 30px;
  align-items: center;
}

.item .content .title .name {
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}

.item .content .title .num {
  font-size: 11px;
  height: 20px;
  line-height: 20px;
  padding: 0 4px;
  border-radius: 5px;
  color: #ffffff;
  background-color: #409EFF;
  margin-left: 10px;
  display: flex;
  align-items: center;
}

.item .content .addr {
  display: block;
  line-height: 16px;
  margin: 0 12px;
  color: #848484;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  padding: 5px 0 12px 0;
}

.item .edit {
  background: #fff;
  margin-top: 1px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  line-height: 40px;
}

.item .edit .def {
  display: flex;
  align-items: center;
  margin-left: 12px;
}

.item .edit .def img {
  width: 13px;
  height: 13px;
}

.item .edit .btn-groups {
  display: flex;
  align-items: center;
  margin-right: 12px;
}

.item .edit .btn-groups .div-btn {
  display: flex;
  align-items: center;
  margin-left: 15px;
}

.item .edit .btn-groups .div-btn img {
  width: 10px;
  height: 10px;
}

.item .edit .btn-groups .div-btn span {
  margin-left: 5px;
  font-size: 12px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
}

/* 底部 */

.bottom {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 15px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  background-color: #efeff4;
}

/deep/ .nut-textinput.my-input input {
  height: 36px;
  margin: 10px 15px;
  border-radius: 20px;
  padding-left: 40px;
  padding-right: 40px;
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg version='1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M15.8 14.3l-3.3-3.1c1-1.1 1.6-2.6 1.6-4.1 0-3.6-3.1-6.6-7-6.6s-7 3-7 6.6c0 3.6 3.1 6.6 7 6.6 1.7 0 3.2-.6 4.4-1.5l3.3 3.1c.1.1.3.2.5.2s.4-.1.5-.2c.3-.3.3-.7 0-1zM1.5 7.1c0-2.9 2.5-5.2 5.6-5.2 3.1 0 5.6 2.3 5.6 5.2 0 2.9-2.5 5.2-5.6 5.2-3.2 0-5.6-2.3-5.6-5.2z' fill-rule='evenodd' clip-rule='evenodd' fill='%23999'/%3E%3C/svg%3E") no-repeat 10px;
  background-size: 18px;
}

/* checkbox未选中时样式 */
.checkbox {
  font-size: 12px;
  margin-right: 0;
}

/deep/ .nut-checkbox.nut-checkbox-size-base input {
  width: 0.50667rem;
  height: 0.50667rem;
}

/deep/ .nut-checkbox input {
  border: none;
  transform: scale(0.8);
  border-radius: 50%; /* 圆角 */
  background-size: 100%;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAMAAAC6CgRnAAAAUVBMVEVHcEze3t7e3t7g4ODf39/e3t7d3d3f39/d3d3f39/d3d3d3d3b29ve3t7e3t7d3d3d3d3d3d3d3d3d3d3a2trd3d3////d3d3////e3t7d3d2Us21MAAAAGnRSTlMA7Loxbv1TEPt+/YgO9cBicabV8jBMA/wBL44nD+0AAACrSURBVCjPfZJZEoMgEEQHEFE2ZVGTvv9Bs5QxpSHTf9SrYZZuol1mSrlsJafJ0FnGBXwU3In2AjbO1a++ztFC9F80akh1vJSEHg+EoTt16AbssNfDcmm/DPr9rRHo6KoO4jWQg6RfSbhnWbCqwZQNhiZEailiooS5yWYkyrg3WUWmAt9kHoU2rE22YmPrMurfftyc3H7cXbh7sj5w/rG+043JC5szNp/tXD8ABfENnsx7b3gAAAAASUVORK5CYII=");
}

/deep/ .nut-checkbox.nut-checkbox-size-base .nut-checkbox-label {
  font-size: 12px;
}

/* 选中后的 背景样式 （红色背景 无边框 可根据UI需求自己修改） */
.checkbox :checked {
  border: none;
  background-image: url("data:image/png;base64,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");
  border-radius: 50%;
  background-size: 100%;
  background-color: inherit;
}

/* checkbox选中时样式 */
.checkbox ::after {
  position: absolute;
  left: 50%;
  top: 50%;
  content: '';
  width: 0;
  height: 0;
  transform: translate(-50%, -50%);
  background: none;
  border-radius: 1%;
  opacity: 0;
  pointer-events: none;
}

>>> .nut-button {
  background: #409EFF;
}

>>> .nut-dialog-ok {
  background: #409EFF;
  border-top: 1px solid #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/LaunchAddress.vue